<template>
  <div class="audio-player-volume-btn-wrap">
    <v-menu
      top
      origin="center bottom"
      transition="scale-transition"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="audio-player__play-icon"
          :color="color"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-volume-high</v-icon>
        </v-btn>
      </template>
      <div class="audio-player-volume-slider">
        <v-slider
          v-model="volume"
          hide-details
          :color="color"
          track-color="#ddd"
          :thumb-color="color"
          :min="1"
          :max="100"
          vertical
          dense
        ></v-slider>
      </div>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'VolumeButton',
    props: {
      value: Number,
      color: String,
    },
    data () {
      return {
        isShowVolume: false,
      }
    },
    emits: ['volume-changed'],
    computed: {
      volume: {
        get () {
          return this.value * 100
        },
        set (value) {
          this.$emit('input', value / 100)
        },
      },
    },
  }
</script>

<style scoped lang="less">
.audio-player {
  &-volume-btn-wrap {
    position: relative;
    touch-action: none;
    user-select: none;
    -webkit-user-drag: none;
    display: inline-flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.5s;
  }

  &-volume-slider {
    background-color: #fff;
    padding: 15px 0;
  }
}
</style>
